import { ReactNode } from 'react';
import { MuiDatePickerLocalizationProvider } from '../../../../../modules/material';
import { DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { getDateFnsLocale } from '../../../../../helpers/getDateFnsLocale';

import { StyledDatePicker } from './styles';

export interface DatePickerProps extends MuiDatePickerProps<unknown> {
  locale?: string;
  required?: boolean;
  error?: boolean;
  name?: string;
  helperText?: ReactNode;
  fullWidth?: boolean;
}

export default function DatePicker(props: DatePickerProps) {
  const {
    locale = 'en',
    required = false,
    error = false,
    helperText,
    fullWidth = true,
    slotProps: { textField, ...slotProps } = {},
    ...datePickerProps
  } = props;
  const fnsLocale = getDateFnsLocale(locale as string);

  return (
    <MuiDatePickerLocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={fnsLocale}
    >
      <StyledDatePicker
        slotProps={{
          textField: {
            variant: 'outlined',
            InputProps: {
              label: undefined,
            },
            InputLabelProps: {
              variant: 'filled',
            },
            required,
            error,
            helperText,
            fullWidth,
            ...textField,
          },
          ...slotProps,
        }}
        {...datePickerProps}
      />
    </MuiDatePickerLocalizationProvider>
  );
}
